import React, { Component } from "react";
import {
  HashRouter as Router,
  Route,
  Redirect,
  Switch
} from "react-router-dom";
import Main from "../Routes/Main";
import Target from "../Routes/Target";
import Opinion from "../Routes/Opinion";
import Reason from "../Routes/Reason";
import Example from "../Routes/Example";
import Offer from "../Routes/Offer";
import Finish from "../Routes/Finish";
import Footer from "../Component/Footer";
import { Helmet } from "react-helmet";

class Routing extends Component {
  render() {
    return (
      <Router>
        <Helmet>
          <link
            rel="shortcut icon"
            type="image/png"
            href="https://victorlee917.github.io/oreo/favicon.png"
          />
        </Helmet>
        <Footer></Footer>
        <Switch>
          <Route path="/" exact component={Main} />
          <Route path="/target" exact component={Target} />
          <Route path="/opinion" exact component={Opinion} />
          <Route path="/reason" exact component={Reason} />
          <Route path="/example" exact component={Example} />
          <Route path="/offer" exact component={Offer} />
          <Route path="/finish" exact component={Finish} />
          <Redirect from="*" to="/" />
        </Switch>
      </Router>
    );
  }
}

export default Routing;
